import { useQuery } from '@tanstack/react-query';

import { fetchContainerType } from '../../data-provider/select-options';

export const useGetContainerType = () => {
  return useQuery({
    queryFn: () => fetchContainerType(),
    queryKey: ['shipment-container-type-list'],
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
